"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _quarkCore = require("quark-core");

var _BaseAlert = _interopRequireDefault(require("../BaseAlert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SuccessAlert = function SuccessAlert(props) {
  return React.createElement(_quarkCore.GetTheme, null, function (_ref) {
    var green = _ref.green;
    return React.createElement(_BaseAlert.default, _extends({
      dismissable: true,
      style: {
        backgroundColor: green
      },
      icon: React.createElement(_quarkCore.IconCheckCircle, null)
    }, props));
  });
};

var _default = SuccessAlert;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/SuccessAlert/index.js
// module id = ./node_modules/quark-web/components/alerts/SuccessAlert/index.js
// module chunks = 0